module.exports = __webpack_public_path__ + "img/cloud.533aa262.png";